module.exports = __webpack_public_path__ + "img/wendy-fung_banner.4072b246.jpg";